import { GuidHelper } from "@/Common/Helpers/GuidHelper";
import { Person } from "@/Common/Models/Person/Person";
import * as LocalOperations from "@/Common/Operations/operations.local";
import * as SubServerOperations from "@/Common/Operations/operations.server.sub";
import { LocalEvent } from "@/Common/Stores/Actions/LocalEvent";
import { BaseOperationHandler } from "@/Common/Stores/Handlers/Local/BaseOperationHandler";
import { DocumentNote } from "@/Documents/Api/Dto/Response/DocumentNote";
import { MedicalDocumentTableItem } from "@/Documents/Models/Medical/MedicalDocumentTableItem";
import { IDocumentInformation } from "@/Documents/Models/UI/IDocumentCreateEditUIModel";
import { DocumentsStore } from "@/Documents/Stores/DocumentsStore";

class DocumentNotesHandler extends BaseOperationHandler {
    constructor() {
        super();

        this.RegisterOperation(LocalOperations.Documents.Note_Dropdown_Save, this.saveDocumentMetadataWithNote);
        this.RegisterOperation(LocalOperations.Documents.View_AddNewNote, this.saveDocumentNoteInView);
        this.RegisterOperation(LocalOperations.Documents.Note_Load, this.loadDocumentNote);
        this.RegisterOperation(LocalOperations.Documents.Note_Dropdown_Closed, this.onNotesDropdownClosed);
        this.RegisterOperation(LocalOperations.Documents.CancelNotesDropdown, this.onContainerClick, false);
        this.RegisterOperation(LocalOperations.Misc.MyleApp_Container_Click, this.onMultiFilePopupClose, false);
    }

    private saveDocumentMetadataWithNote(request: LocalEvent, store: DocumentsStore): void {
        const documentData = request.Get<IDocumentInformation>("documentData");
        store.DocumentActions.UpdateDocumentMetadata(documentData);
    }

    private saveDocumentNoteInView(request: LocalEvent, store: DocumentsStore): void {
        let noteText = request.Get<string>("value");
        let mdoc = store.DocumentsModel.get("SelectedDocument").get("MedicalDocumentInfo");

        var docId = mdoc.Model.Id;
        // push new note

        var note = new DocumentNote();
        note.NoteContent = noteText;
        note.NoteDate = new Date();
        note.NoteId = GuidHelper.NewGuid(); // this is a false id but no harm here..
        note.ContactId = sessionStore.individualContactId;
        mdoc.Model.NoteInfoCollection.unshift(note);

        var doc = store.DocumentsModel.get("SelectedDocument");
        doc = doc.delete("MedicalDocumentInfo");
        doc = doc.set("MedicalDocumentInfo", mdoc);
        store.DocumentsModel = store.DocumentsModel.set("SelectedDocument", doc);

        store.DocumentActions.SaveDocumentNote(noteText, docId, SubServerOperations.Documents.CreateNoteFromForm);
    }

    private loadDocumentNote(request: LocalEvent, store: DocumentsStore): void {
        const item = request.Get<MedicalDocumentTableItem>("item");
        const event = request.Get<React.MouseEvent>("event");
        let selectedDocument = store.DocumentsModel.get("SelectedDocument");

        const selectedClinicians = item.Model.Model.ResponsibleProviders.map(provider => cacheStore.GetClinicians(true).firstOrDefault(contact => contact.ContactFacetId === provider.Id || contact.ContactId === provider.Id));

        store.DocumentsModel = store.DocumentsModel.set("TargetElement", event.nativeEvent.target as HTMLElement);
        store.DocumentsModel = store.DocumentsModel.set("CurrentDocumentNotes", Immutable.List(item.Model.Model.NoteInfoCollection));
        store.DocumentsModel = store.DocumentsModel.set("CurrentDocumentIDForNotes", item.Model.Model.Id);
        store.DocumentsModel = store.DocumentsModel.set("NoteWindowOpen", true);
        store.DocumentsModel = store.DocumentsModel.set("TopPosition", event.clientY);
        store.DocumentsModel = store.DocumentsModel.set("LeftPosition", event.clientX - 600);

        selectedDocument = selectedDocument.set("MedicalDocumentInfo", item.Model);
        selectedDocument = selectedDocument.set("SelectedClinicians", Immutable.List<Person>(selectedClinicians));
        store.DocumentsModel = store.DocumentsModel.set("SelectedDocument", selectedDocument);
    }

    private onNotesDropdownClosed(request: LocalEvent, store: DocumentsStore): void {
        store.DocumentsModel = store.DocumentsModel.set("CurrentDocumentNoteValue", "");
        store.DocumentsModel = store.DocumentsModel.set("CurrentDocumentIDForNotes", "");
        store.DocumentsModel = store.DocumentsModel.set("CurrentDocumentNotes", Immutable.List([]));
    }

    private onContainerClick(request: LocalEvent, store: DocumentsStore): void {
        if (store.DocumentsModel.get("NoteWindowOpen") === true) {
            store.DocumentsModel = store.DocumentsModel.set("NoteWindowOpen", false);
            $("table.myle-table tbody tr").removeClass("active");
            store.EmitChangeToListeners();
        }
        if (store.DocumentsModel.get("MulitFilePopupOpen") === true) {
            store.DocumentsModel = store.DocumentsModel.set("MulitFilePopupOpen", false);
            sessionStore.hideGlobalOverlay();
            store.EmitChangeToListeners();
        }
    }

    private onMultiFilePopupClose(_: LocalEvent, store: DocumentsStore): void {
        if (store.DocumentsModel.get("MulitFilePopupOpen") === true) {
            store.DocumentsModel = store.DocumentsModel.set("MulitFilePopupOpen", false);
            overlayStore.hideOverlay("global-overlay");
            store.EmitChangeToListeners();
        }
    }
}

export { DocumentNotesHandler };
